import { render, staticRenderFns } from "./MobileRowAsset.vue?vue&type=template&id=72f85056"
import script from "./MobileRowAsset.vue?vue&type=script&lang=js"
export * from "./MobileRowAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports